import React, {Component} from 'react';
import {section, query} from '@jump/pages';
import FilterPanel from './js/FilterPanel';
import Grid from './js/Grid'
import Toggle from './js/Toggle'
import Table from './js/Table'
import SearchFilter from './js/SearchFilter'

class Root extends Component {

  state = {
    selectedValues: {},
    layout: "grid",
    overlay : false
  };

  _onChange = (id, selected) => {
    const {queries: {parts}} = this.props;
    const selectedValues = {
      ...this.state.selectedValues,
      [id]: selected
    };

    parts.update({
      values: JSON.stringify(selectedValues),
    });

    this.setState({
      selectedValues
    });
  };

  _updateLayout = (newLayout) => {
    this.setState({
      layout: newLayout
    });
  };

  _resetFilter = () => {
    this.setState({
      selectedValues : {}
    });

    const {queries: {parts}} = this.props;

    parts.update({
      values: JSON.stringify({}),
    });

  };

  _onCategorySelect = evt => {
    if(!evt.target.val) {
      window.location = evt.target.value;
    }
  };

  render() {
    const {
      queries: {
        filters,
        parts,
        product,
        category
      }
    } = this.props;


    const {layout, selectedValues} = this.state;

    if (!parts.loaded || !filters.loaded || !product.loaded || !category.loaded) {
      return <p>Loading...</p>;
    }

    const categories = product.results.categories;
    const showCategories = !! categories.length;

    return (
      <div className="o-FlexRow o-FlexRow--fw-wrap">

        <div className="o-Grid__row">
          <div className="o-Grid__column--100" style={layout === 'grid' ? {display: "none"} : {display: "block"}}>
            <div className="c-SearchFilter__header">
              Search
            </div>
            <div className="c-SearchFilter__container">
              {filters.results.map((filter) => (
                <SearchFilter
                  key={filter.id} {...filter}
                  selected={selectedValues[filter.id] || []}
                  onChange={(values) => this._onChange(filter.id, values)}
                />
              ))}

              <div className="c-SearchFilter__reset-button">
                <button className="button button--blue" onClick={this._resetFilter}>Reset</button>
              </div>
            </div>
          </div>

          <div className="o-Grid__column--100">
            <Toggle updateLayout={this._updateLayout} selected={layout} partsDetails={{
              total: parts.pagination.total,
              matching: parts.results.length
            }}/>
          </div>

          {showCategories && (<div className="c-Product__dropdown">
            <p>You can also select a Product Family to further filter your results:</p>
            <div className="c-Product__select">
              <select name="product" onChange={this._onCategorySelect}>
                <option value={`/products/${product.results.slug}`}>{`All ${product.results.title}`}</option>
                {categories.map(cat => (
                  <option
                    value={`/products/${product.results.slug}/${cat.slug}`}
                    key={cat.slug}
                    selected={category.results ? category.results.slug === cat.slug : false}
                  >
                    {cat.title}
                  </option>
                ))}
              </select>
            </div>
          </div>)}

          <div className="o-Grid">
            <div className="o-Grid__column--33 u-hidden-sm" style={layout === 'list' ? {display: "none"} : {display: "block"}}>
              <h2 className="c-PartFilters__title">Filter By</h2>
              <div className="c-PartFilters">
                {filters.results.map((filter) => (
                  <FilterPanel
                    key={filter.id} {...filter}
                    selected={selectedValues[filter.id] || []}
                    onChange={(values) => this._onChange(filter.id, values)}
                  />
                ))}
              </div>
            </div>

            <div className={layout === 'list' ? "o-Grid__column--100" : "o-Grid__column--66"}>
              {parts.loaded && !parts.results.length &&
              <p className="c-Product__parts-not-found">
                <strong>No Available Parts</strong>
              </p>
              }
              {layout === 'list' && <Table filters={filters.results} parts={parts.results} />}
              {layout === 'grid' && <Grid parts={parts.results} layout={layout}/>}

              <div className="c-Product__button">
                {parts.canLoadMore &&
                <button className="button button--blue" onClick={parts.loadMore}>Load More</button>
                }
              </div>
            </div>
          </div>
        </div>

        <div className={this.state.overlay ? "u-overlay is-active" : "u-overlay"}>1</div>
      </div>
    );
  }
}

export default section({
  name: 'product',
  component: Root,
  queries: [
    query('filters'),
    query.loadMore('parts', {
      values: '{}',
      page: 1,
    }),
    query('product'),
    query('category')
  ],
});




// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/product/index.js